/* eslint-disable linebreak-style */
import React from 'react';

const Statement = () => (
  <>
    <p style={{ color: '#ff0098', lineHeight: 1, padding: 120 }}>
      Mathematics is not about numbers, equations, computations or algorithms: it is
      about understanding. -William Paul Thurston
    </p>
  </>
);

export default Statement;
